import React from 'react'
import { InputText } from 'primereact/inputtext'

const AdpositionInput = ({
  name,
  value,
  showCheckBox,
  handleChange,
  idx
}) => {
  return (
    <div className="param-input adpos">
      <InputText name={name} value={value} disabled={!showCheckBox} onChange={e => handleChange(e, idx)} />
    </div>
  )
}

export default AdpositionInput
